import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import textTypes from '../textLabel/textTypes';
var RichText = function RichText(props) {
  return /*#__PURE__*/React.createElement('div', {
    className: props.getClassName("control-rich-text ".concat(props.type.toLowerCase())),
    'data-aid': props.automationId,
    'data-hook': props.dataHook
  }, props.children);
};
RichText.displayName = displayNames.RICH_TEXT;
RichText.propTypes = {
  children: PropTypes.any.isRequired,
  type: PropTypes.oneOf(textTypes.TYPES)
};
RichText.defaultProps = {
  type: textTypes.DEFAULT_TYPE
};
export default compose(RichText);